import axios from 'axios'


const getToken = async (email, password) => {
    let response;
    var config = {
        method: 'post',
        url: process.env.REACT_APP_BASE_URL+'/api/v1/login/auth',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: {
            email : email,
            password : password
        },
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            response = err;
        });
    return response;
};

export default getToken;